<template>
  <div>
    <GlobalHead />
    <div class="top" style="">
      <img style="width: 100%;height: 200px" src="@/assets/jiopweb3.0.0/publicService.png" alt="">
      <div class="word">
        <h1 class="bigWord">{{ subjectName }}</h1>
        <h4 class="smallWord">欢迎使用该服务！</h4>
      </div>
    </div>
    <div class="mid">
      <div style="margin: 100 0">
        <div style="font-size: 22px;color: #2B2F32;font-weight: 600;padding-bottom: 20px;">{{ subjectName }}</div>
        <a-row :gutter="25" >
          <a-col class="gutter-row" :span="8" v-for="(item,index) in matterList" :key="index">
            <div class="gutter-box" @click="hitMe(item.iid)">
              <a-tooltip>
                <template slot="title">
                  {{ item.itemName }}
                </template>
                <strong>{{ item.itemName }}</strong>
              </a-tooltip>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- <GlobalFoot style="margin-top: 10px"/> -->
  </div>
</template>
<script>
import GlobalHead from '@/views/layout/globalHead.vue'
// import GlobalFoot from '@/views/layout/globalFood.vue'
import { jiopAPI } from '@/api/jiopweb/jiop'
export default {
  name: 'LocalFeature',
  components: {
    GlobalHead
    // GlobalFoot
  },
  data () {
    return {
      imgSrc: '@/assets/jiopweb3.0.0/publicService.png',
      showList: [
        '租房提取',
        '购房提取',
        '建造自住房提取',
        '偿还购房贷款本息提取',
        '死亡提取',
        '出境定居提取',
        '购买自住房贷款'
      ],
      subjectId: '',
      itemType: '',
      matterList: [],
      subjectName: ''
    }
  },
  created () {
    this.subjectId = this.$route.query.subjectId
    this.itemType = this.$route.query.itemType
    this.subjectName = this.$route.query.subjectName
    this.findItem()
  },
  methods: {
    findItem () {
      jiopAPI.findItemBySybject({ subjectId: this.subjectId, itemType: this.itemType }).then(res => {
        if (res.success) {
          this.matterList = res.data.matterList
        }
      })
    },
    hitMe (iid) {
      const url = this.$router.resolve({ path: '/guideSimple', query: { itemId: iid, bannerType: this.$route.query.bannerType } })
      window.open(url.href, '_blank')
    }
  }

}
</script>
<style lang="less" scoped>
.top{
	position: relative;
  margin-bottom: 30px;
}
.bigWord{
  font-size: 36px;
  color: white;
  position:absolute;
  top:50px;
}
.smallWord{
  font-size: 16px;
  color: white;
  position:absolute;
  top:120px;
}
.gutter-box {
  box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  height: 80px;
  padding: 5px 30px;
  font-size: 16px;
  cursor:pointer;
  line-height: 70px;
  overflow: hidden;
  align-items: center;
  margin-bottom: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 320px;
}
.gutter-box:hover {
  box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  height: 80px;
  padding: 5px 30px;
  font-size: 16px;
  cursor:pointer;
  background: #E7F1FF;
  color: #1777FF;
  overflow: hidden;
  line-height: 70px;
  margin-bottom: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 320px;
}
.mid{
  width: 1200px;
  margin: 0 auto;
  padding-top: 10px;
}
.word{
  width: 1200px;
  margin: 0 auto;
}
</style>
